"use client";
import React from "react";

export class SuppressErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    if (error.message.includes("removeChild")) {
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (!error.message.includes("removeChild")) {
      console.error("Unexpected error:", error, errorInfo);
    }
  }

  render() {
    return this.props.children;
  }
}